import { useEffect, useRef } from "react";

// Actualisation périodique : la demande suivante n'est programmée qu'après la fin de la précédente
// (jamais 2 en cours), annulée en quittant l'écran, suspendue quand l'app est en arrière-plan.
// `load(signal)` doit renvoyer une promesse et transmettre `signal` à la requête.
export function usePolling(load, intervalMs, deps) {
  const loadRef = useRef(load);
  loadRef.current = load;
  useEffect(() => {
    let stopped = false;
    let running = false;
    let timer = null;
    let ctrl = null;
    // Pas d'actualisation app en arrière-plan ou hors réseau ; reprise immédiate au retour du réseau (P11).
    const hidden = () => document.visibilityState === "hidden" || (typeof navigator !== "undefined" && navigator.onLine === false);
    const schedule = () => {
      clearTimeout(timer);
      if (!stopped && !hidden()) timer = setTimeout(run, intervalMs);
    };
    const run = async () => {
      if (stopped || running || hidden()) return;
      running = true;
      ctrl = new AbortController();
      try { await loadRef.current(ctrl.signal); } catch (e) { /* erreurs gérées par l'appelant */ }
      running = false;
      schedule();
    };
    const onVisibility = () => {
      if (hidden()) clearTimeout(timer);
      else if (!running) { clearTimeout(timer); run(); }
    };
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("online", onVisibility);
    window.addEventListener("offline", onVisibility);
    run();
    return () => {
      stopped = true;
      clearTimeout(timer);
      if (ctrl) ctrl.abort();
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("online", onVisibility);
      window.removeEventListener("offline", onVisibility);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
